import React, { useState, useEffect } from 'react';
import axios from 'axios';
import {
  Button,
  Layout,
  PageHeader,
  Card,
  Table,
  Modal,
  Input,
  Radio,
  Typography,
  Divider,
  Select,
  Switch,
  Checkbox,
  Spin,
  Popconfirm,
  Alert,
  message,
} from 'antd';
import EmojiPicker from './jira/emojiPicker';
// import { convert } from 'html-to-text'
import {
  getProject,
  getIssues,
  getEmojiActions,
  createEmojiAction,
  deleteEmojiAction,
  updateEmojiAction,
  dropDownSearchJiraProjects,
  searchJiraProjects,
  getConfluenceSpaces,
  getServiceDeskProject,
  emptyProjectValues,
  getChannelList,
  getCustomEmojis,
  getAllResolutionsInTheDomain,
} from './skills_action';
import { emojis } from '../../utils/slackemojis';
import { connect } from 'react-redux';
import JiraIssueFields from './jira/jiraIssueFields';
import JiraCommonIssueFields from './jira/jiraCommonIssueFields';
import queryString from 'query-string';


import RichTextEditor from './cardSkill/richTextEditor';
import { set } from 'react-ga';

const { Content } = Layout;
const { Text } = Typography;
const { Option } = Select;

function EmojiActions(props) {
  const {
    allProjects,
    issues,
    isAdmin,
    getIssues,
    skills,

    team,
    user_now,
    dropDownSearchJiraProjects,
    searchJiraProjects,
    getProject,
    getServiceDeskProject,
    getConfluenceSpaces,
    confluence_spaces,
    jsd_projects,
    requestTypes,
    emptyProjectValues,
    channels,
    getChannelList,
    match: {
      params: { wId },
    },
  } = props;
  let parsed_query = queryString.parse(props.location.search);
  const jiraSkill = skills.find((skill) => skill.key === 'jira');
  const wikiSkill = skills.find((skill) => skill.key === 'wiki');

  const isJiraProductsEnabled =
    jiraSkill &&
    jiraSkill.skill_metadata &&
    jiraSkill.skill_metadata.sub_skills.find((ss) => !ss.disabled);
  const helpdeskSubSkill =
    jiraSkill &&
    jiraSkill.skill_metadata &&
    jiraSkill.skill_metadata.sub_skills.find(
      (ss) => ss.key === 'jira_service_desk'
    );
  const jiraSkill_linked =
    jiraSkill && jiraSkill.skill_metadata && jiraSkill.skill_metadata.linked;
  const isWikiEnabled =
    wikiSkill && wikiSkill.skill_metadata && !wikiSkill.skill_metadata.disabled;
  const wikiSKill_linked =
    wikiSkill && wikiSkill.skill_metadata && wikiSkill.skill_metadata.linked;

  const projects = !helpdeskSubSkill
    ? allProjects &&
    allProjects.filter((project) => project.projectTypeKey !== 'service_desk')
    : allProjects;

  const [isCreating, set_isCreating] = useState(false); //set_isCreating(false)
  const [actionType, set_actionType] = useState('create'); //set_actionType('create')
  const [emoji_action_scope, set_emoji_action_scope] = useState('workspace'); //set_actionType('create')
  const [creationDefaultProject, set_creationDefaultProject] = useState(null); //set_creationDefaultProject(null)
  const [createRequestDefaultProject, set_createRequestDefaultProject] =
    useState(null); //set_creationDefaultProject(null)
  const [creationDefaultIssueType, set_creationDefaultIssueType] =
    useState(null); //set_creationDefaultIssueType(null)
  const [createRequestDefaultRequestType, set_createRequestDefaultRequestType] =
    useState(null); //set_creationDefaultIssueType(null)
  const [selectedSpace, set_selectedSpace] = useState(null); //set_creationDefaultIssueType(null)
  const [selectedSearchSpaces, set_selectedSearchSpaces] = useState([]); //set_creationDefaultIssueType(null)
  const [fieldDefaultsModalVisible, set_fieldDefaultsModalVisible] =
    useState(false);
  const [updateAction, set_updateAction] = useState('update'); //set_updateAction("update")
  const [selected_channels, set_selected_channels] = useState([]); //set_updateAction("update")
  const [useChannelDefaults, set_useChannelDefaults] = useState(false); // set_useChannelDefaults(false)
  const [emojiModalView, set_emojiModalView] = useState(false);
  const [emojiModalViewForDefaultAction, set_emojiModalViewForDefaultAction] =
    useState(false);
  const [customEmojisFromSlack, set_customEmojisFromSlack] = useState([]);
  const [selectedEmoji, set_selectedEmoji] = useState(null); //set_selectedEmoji(null)
  const [purpose, set_purpose] = useState(null); //set_purpose(null)
  const [fieldDefaults, set_fieldDefaults] = useState({}); //set_fieldDefaults({})
  const [fieldsMetaData, set_fieldsMetaData] = useState({}); //set_fieldDefaults({})
  // const [projectLoading, set_projectLoading] = useState(true);
  const [issueLoading, set_issueLoading] = useState(false);
  const [requestTypeLoading, set_requestTypeLoading] = useState(false);
  const [emojiError, set_emojiError] = useState(false); //set_emojiError(false)
  const [emojiAlreadyUsedError, set_emojiAlreadyUsedError] = useState(false); //set_emojiAlreadyUsedError(false)
  const [
    channelAlreadyUsedforSameEmojiError,
    set_channelAlreadyUsedforSameEmojiError,
  ] = useState(false);
  const [purposeError, set_purposeError] = useState(false); //set_purposeError(false)
  const [channelsError, set_channelsError] = useState(false);
  const [projectError, set_projectError] = useState(false); //set_projectError(false)
  const [requestProjectError, set_requestProjectError] = useState(false); //set_projectError(false)
  const [issuetypeError, set_issuetypeError] = useState(false); //set_issuetypeError(false)
  const [requestTypeError, set_requestTypeError] = useState(false); //set_issuetypeError(false)
  // const [spaceError, set_spaceError] = useState(false);
  const [fieldDefaultsError, set_fieldDefaultsError] = useState(false); //set_fieldDefaultsError(false)
  const [emojiActions, set_emojiActions] = useState([]);
  const [selectedActionForUpadate, set_selectedActionForUpadate] =
    useState(null); //set_selectedActionForUpadate(false)
  const [apiLodaing, set_apiLodaing] = useState(false); //set_apiLodaing(false)
  const [creationFormMode, set_creationFormMode] = useState('never'); //set_apiLodaing(false)
  const [scopeFilterValue, set_scopeFilterValue] = useState(
    parsed_query && parsed_query.scope ? [parsed_query.scope] : []
  );
  const [resolutions, set_resolutions] = useState([]);
  const [selectedResolution, set_selectedResolution] = useState(null);
  const [editorState, setEditorState] = useState('');
  const [replyMessage, setReplyMessage] = useState('');
  const [editorContent, setEditorContent] = useState(null);
  const [editorErrorMessage, setEditorErrorMessage] = useState('');
  const maxCharacterLimit = 256;

  const resetStates = () => {
    set_isCreating(false);
    set_actionType('create');
    set_emoji_action_scope('workspace');
    set_creationDefaultProject(null);
    set_creationDefaultIssueType(null);
    set_selectedSpace(null);
    set_selectedSearchSpaces([]);
    set_updateAction('update');
    set_useChannelDefaults(false);
    set_selectedEmoji(null);
    set_purpose(null);
    set_fieldDefaults({});
    set_emojiError(false);
    set_emojiAlreadyUsedError(false);
    set_channelAlreadyUsedforSameEmojiError(false);
    set_purposeError(false);
    set_channelsError(false);
    set_projectError(false);
    set_issuetypeError(false);
    set_fieldDefaultsError(false);
    set_selectedActionForUpadate(null);
    set_apiLodaing(false);
    set_creationFormMode('never');
    set_creationDefaultIssueType(null);
    set_createRequestDefaultRequestType(null);
    set_requestProjectError(false);
    set_requestTypeError(false);
    set_selected_channels([]);
    set_scopeFilterValue([]);
    set_resolutions([]);
    set_selectedResolution(null);
    setEditorState('');
    setReplyMessage('');
    setEditorContent(null);
    setEditorErrorMessage('');
    // set_spaceError(false)
  };



  useEffect(() => {
    (async function () {
      try {
        const emojis = await getCustomEmojis(wId);
        set_customEmojisFromSlack(emojis);
      } catch (e) {
        console.error(e);
      }
    })();

    getEmojiActions(wId).then((res) => {
      if (res.success) set_emojiActions(res.emojiActions);
    });
    emptyProjectValues();

    if (channels.length === 0) {
      getChannels();
    }
  }, []);

  useEffect(() => {
    if (parsed_query.scope) set_scopeFilterValue([parsed_query.scope]);
    else set_scopeFilterValue([]);

    if (parsed_query.scope && parsed_query.scope === 'personal') {
      message.info('The scope filter is set to Personal!');
    }
  }, [parsed_query.scope]);

  // useEffect(() => {
  //   if (jiraSkill && jiraSkill.skill_metadata && jiraSkill.skill_metadata.linked) getRequiredData();
  // }, [jiraSkill]);

  // useEffect(() => {
  //   if (wikiSkill && wikiSkill.skill_metadata && wikiSkill.skill_metadata.linked) {
  //     getConfluenceSpaces(wId);
  //   }
  // }, [wikiSkill]);

  const getRequiredData = ({ actionType, emojiAction }) => {
    const skill_key =
      actionType === 'add_to_confluence' || actionType === 'search_confluence'
        ? 'wiki'
        : 'jira';

    if (skill_key === 'jira') {
      if (actionType === 'create_request') {
        if (jiraSkill && jiraSkill.skill_metadata && jsd_projects.length === 0)
          getServiceDeskProject(wId, jiraSkill.skill_metadata._id, {
            saveInJSDProjects: true,
          });
      } else if (
        // projects.length === 0 &&
        jiraSkill &&
        jiraSkill.skill_metadata &&
        jiraSkill.skill_metadata.metadata &&
        jiraSkill.skill_metadata.metadata.server_type
      ) {
        const server_type = jiraSkill.skill_metadata.metadata.server_type;

        if (projects.length === 0) {
          if (
            server_type === 'jira_server_oauth' ||
            server_type === 'jira_server'
          ) {
            getProject(wId);
          } else {
            searchJiraProjects(wId, '').then((res) => {
              if (res && res.data && res.data.success) {
                if (
                  emojiAction &&
                  emojiAction.actionType === 'create' &&
                  !emojiAction.arguments.useChannelDefaults &&
                  emojiAction.arguments.project &&
                  emojiAction.arguments.project.id &&
                  res.data.projectsData &&
                  !res.data.projectsData.values.find(
                    (p) => p.id === emojiAction.arguments.project.id
                  )
                ) {
                  getMissingProject(emojiAction.arguments.project.id);
                }
                if (
                  emojiAction &&
                  emojiAction.actionType === 'update' &&
                  emojiAction.arguments.project &&
                  emojiAction.arguments.project.id &&
                  res.data.projectsData &&
                  !res.data.projectsData.values.find(
                    (p) => p.id === emojiAction.arguments.project.id
                  )
                ) {
                  getMissingProject(emojiAction.arguments.project.id);
                }
              }
            });
          }
        } else {
          if (
            emojiAction &&
            emojiAction.actionType === 'create' &&
            !emojiAction.arguments.useChannelDefaults &&
            emojiAction.arguments.project &&
            emojiAction.arguments.project.id &&
            !projects.find((p) => p.id === emojiAction.arguments.project.id)
          ) {
            getMissingProject(emojiAction.arguments.project.id);
          }
          if (
            emojiAction &&
            emojiAction.actionType === 'update' &&
            emojiAction.arguments.project &&
            emojiAction.arguments.project.id &&
            !projects.find((p) => p.id === emojiAction.arguments.project.id)
          ) {
            getMissingProject(emojiAction.arguments.project.id);
          }
        }

        if (actionType === 'update') {
          getAllResolutionsInTheDomain(wId).then((res) => {
            if (res.success) set_resolutions(res.resolutions);
          });
        }
      }
    } else if (skill_key === 'wiki') {
      if (confluence_spaces.length == 0) getConfluenceSpaces(wId);
    }
  };

  const getMissingProject = (projectId) => {
    if (
      jiraSkill &&
      jiraSkill.skill_metadata &&
      jiraSkill.skill_metadata.metadata &&
      jiraSkill.skill_metadata.metadata.server_type
    ) {
      const server_type = jiraSkill.skill_metadata.metadata.server_type;

      if (
        server_type === 'jira_server_oauth' ||
        server_type === 'jira_server'
      ) {
      } else {
        const query = `id=${projectId}`;
        dropDownSearchJiraProjects(wId, `?query=${query}`);
      }
    }
  };

  // const troopr_emoji_action = {
  //   emoji: {
  //     name:
  //       (jiraSkill && jiraSkill.skill_metadata && jiraSkill.skill_metadata.creationEmoji && jiraSkill.skill_metadata.creationEmoji.name) ||
  //       ":ticket:",
  //   },
  //   purpose: "Default emoji action that will trigger issue creation based on channel defaults",
  //   created_by: "Troopr",
  //   troopr_action: true,
  // };

  const columns = [
    {
      title: 'Emoji',
      width: 140,
      key: 'emojiname',
      render: (data) => (
        <>
          {emojis[data.emoji.name] ||
            (customEmojisFromSlack[data.emoji.name] ? (
              <img
                style={{ width: '22px', height: '22px' }}
                src={customEmojisFromSlack[data.emoji.name]}
                alt=''
              />
            ) : (
              ''
            ))}{' '}
          {data.emoji.name}
        </>
      ),
    },
    {
      title: 'Purpose',
      width: 160,
      dataIndex: 'purpose',
      key: 'purpose',
      ellipsis: true
    },
    {
      title: 'Creator',
      width: 100,
      key: 'creator',
      render: (data) => {
        if (data.isTrooprAction) return 'Troopr';
        const user = data.created_by
          ? data.created_by.displayName ||
          data.created_by.name ||
          data.created_by.user_name
          : 'Not a member';

        if (user) return user;
      },
    },
    {
      title: 'Scope',
      width: 80,
      key: 'scope',
      dataIndex: 'emoji_action_scope',
      filters: [
        { text: 'Workspace', value: 'workspace' },
        { text: 'Personal', value: 'personal' },
        { text: 'Channel', value: 'channel' },
      ],
      render: (emoji_action_scope) => {
        if (emoji_action_scope === 'workspace') return 'Workspace';
        else if (emoji_action_scope === 'personal') return 'Personal';
        else if (emoji_action_scope === 'channel') return 'Channel';
      },
      filteredValue: scopeFilterValue,
      onFilter: (value, emojiAction) =>
        emojiAction.emoji_action_scope.indexOf(value) === 0,
    },
    {
      title: 'Status',
      width: 60,
      render: (data) => (
        <Switch
          checked={!data.disabled}
          // disabled={!((user_now && data && data.created_by && data.created_by.user_id === user_now._id) || isAdmin)}
          // disabled={(() => {
          //   let disabled = true;
          //   if ((data.actionType === "create" || data.actionType === "update") && jiraSkill_linked && isJiraProductsEnabled) disabled = false;
          //   else if (data.actionType === "add_to_confluence" && isWikiEnabled && wikiSKill_linked) disabled = false;

          //   if (!((user_now && data && data.created_by && data.created_by.user_id === user_now._id) || isAdmin)) disabled = true;

          //   return disabled;
          // })()}
          disabled={checkCondition(data)}
          onChange={(checked) => handleDisableSwitch(checked, data)}
        />
      ),
    },
    {
      width: 80,
      render: (data) =>
        // data.troopr_action ? (
        //   isAdmin ? (
        //     <Button onClick={() => set_emojiModalViewForDefaultAction(true)}>Change</Button>
        //   ) : (
        //     ""
        //   )
        // ) : (
        ((user_now &&
          data.created_by &&
          data.created_by.user_id === user_now._id) ||
          isAdmin) && (
          <>
            <Button
              onClick={() => updateTheAction({ emojiAction: data })}
              // disabled={(() => {
              //   let disabled = true;
              //   if ((data.actionType === "create" || data.actionType === "update") && jiraSkill_linked && isJiraProductsEnabled) disabled = false;
              //   else if (data.actionType === "add_to_confluence" && isWikiEnabled && wikiSKill_linked) disabled = false;

              //   if (!((user_now && data && data.created_by && data.created_by.user_id === user_now._id) || isAdmin)) disabled = true;
              //   return disabled;
              // })()}
              disabled={checkCondition(data)}
            >
              Customize
            </Button>
            {!data.isTrooprAction && (
              <Popconfirm
                title='Are you sure want to delete this emoji action?'
                okText='Delete'
                onConfirm={() => deleteAction(data)}
                placement='leftTop'
                // disabled={(() => {
                //   let disabled = true;
                //   if ((data.actionType === "create" || data.actionType === "update") && jiraSkill_linked && isJiraProductsEnabled) disabled = false;
                //   else if (data.actionType === "add_to_confluence" && isWikiEnabled && wikiSKill_linked) disabled = false;

                //   if (!((user_now && data && data.created_by && data.created_by.user_id === user_now._id) || isAdmin)) disabled = true;

                //   return disabled;
                // })()}
                disabled={checkCondition(data)}
              >
                <Button
                  type='link'
                  // disabled={(() => {
                  //   let disabled = true;
                  //   if ((data.actionType === "create" || data.actionType === "update") && jiraSkill_linked && isJiraProductsEnabled) disabled = false;
                  //   else if (data.actionType === "add_to_confluence" && isWikiEnabled && wikiSKill_linked) disabled = false;

                  //   if (!((user_now && data && data.created_by && data.created_by.user_id === user_now._id) || isAdmin)) disabled = true;

                  //   return disabled;
                  // })()}
                  disabled={checkCondition(data)}
                >
                  <Text type='danger'>Delete</Text>
                </Button>
              </Popconfirm>
            )}
          </>
        ),
      // ),
    },
  ];

  const handleChange = (pagination, filters, sorter) => {
    set_scopeFilterValue(filters.scope);
  };

  const checkCondition = (data) => {
    let disabled = true;
    if (
      (data.actionType === 'create' ||
        data.actionType === 'update' ||
        data.actionType === 'add_comment' ||
        data.actionType === 'create_request' ||
        data.actionType === 'add_reply_message') &&
      jiraSkill_linked &&
      isJiraProductsEnabled
    ) {
      if (data.actionType === 'create_request') {
        if (helpdeskSubSkill && helpdeskSubSkill.disabled) disabled = true;
        else disabled = false;
      } else {
        disabled = false;
      }
    } else if (
      (data.actionType === 'add_to_confluence' ||
        data.actionType === 'search_confluence') &&
      isWikiEnabled &&
      wikiSKill_linked
    )
      disabled = false;

    if (
      !(
        (user_now &&
          data &&
          data.created_by &&
          data.created_by.user_id === user_now._id) ||
        isAdmin
      )
    )
      disabled = true;

    return disabled;
  };

  const handleDisableSwitch = (checked, emojiAction) => {
    updateEmojiAction(wId, emojiAction._id, {
      disabled: !checked,
      team_id: team.id,
    }).then((res) => {
      if (res.success) {
        set_emojiActions(
          emojiActions.map((action) => {
            if (action._id === emojiAction._id) return res.emojiAction;
            else return action;
          })
        );
      }
    });
  };

  const deleteAction = (emojiAction) => {
    deleteEmojiAction(wId, emojiAction._id).then((res) => {
      if (res.success) {
        let updatedEmojiActions = [];
        emojiActions.forEach((action) => {
          if (action._id !== emojiAction._id) updatedEmojiActions.push(action);
        });
        set_emojiActions(updatedEmojiActions);
      }
    });
  };

  const updateTheAction = ({ emojiAction }) => {
    getRequiredData({ actionType: emojiAction.actionType, emojiAction });
    set_selectedActionForUpadate(emojiAction);
    set_isCreating(true);
    set_actionType(emojiAction.actionType);
    set_emoji_action_scope(emojiAction.emoji_action_scope);
    set_selectedEmoji(emojiAction.emoji.name);
    set_purpose(emojiAction.purpose);

    if (emojiAction.arguments) {
      if (emojiAction.arguments.project) {
        if (emojiAction.actionType === 'create_request')
          set_createRequestDefaultProject(emojiAction.arguments.project);
        else if (
          emojiAction.actionType === 'create' ||
          emojiAction.actionType === 'update'
        )
          set_creationDefaultProject(emojiAction.arguments.project);
      }
      if (emojiAction.arguments.issueType)
        set_creationDefaultIssueType(emojiAction.arguments.issueType);
      if (emojiAction.arguments.requestType)
        set_createRequestDefaultRequestType(emojiAction.arguments.requestType);
      if (emojiAction.arguments.fieldDefaults)
        set_fieldDefaults(emojiAction.arguments.fieldDefaults);
      if (emojiAction.arguments.useChannelDefaults)
        set_useChannelDefaults(emojiAction.arguments.useChannelDefaults);
      if (emojiAction.actionType === 'update')
        set_updateAction(emojiAction.arguments.type);
      set_creationFormMode(
        emojiAction.arguments.creationFormMode
          ? emojiAction.arguments.creationFormMode
          : 'never'
      );
      if (
        emojiAction.actionType === 'create' &&
        !emojiAction.arguments.useChannelDefaults &&
        emojiAction.arguments.project &&
        emojiAction.arguments.project.id
      )
        getProjectIssues({
          project_id: emojiAction.arguments.project.id,
          dont_set_issutype: true,
        });

      if (
        emojiAction.actionType === 'update' &&
        emojiAction.arguments.project &&
        emojiAction.arguments.project.id
      ) {
        getProjectIssues({
          project_id: emojiAction.arguments.project.id,
          dont_set_issutype: true,
        });
        if (emojiAction.arguments.fieldsMeta)
          set_fieldsMetaData(emojiAction.arguments.fieldsMeta);
      }

      if (
        emojiAction.actionType === 'create_request' &&
        !emojiAction.arguments.useChannelDefaults &&
        emojiAction.arguments.project &&
        emojiAction.arguments.project.id
      )
        getProjectRequestTypes({
          project_id: emojiAction.arguments.project.id,
          dont_set_requestType: true,
        });
      // if (
      //   emojiAction &&
      //   emojiAction.actionType === 'create' &&
      //   !emojiAction.arguments.useChannelDefaults &&
      //   emojiAction.arguments.project &&
      //   emojiAction.arguments.project.id &&
      //   !projects.find((p) => p.id === emojiAction.arguments.project.id)
      // ) {
      //   getMissingProject(emojiAction.arguments.project.id);
      // }

      if (
        emojiAction.emoji_action_scope === 'channel' &&
        emojiAction.arguments.channels
      ) {
        set_selected_channels(emojiAction.arguments.channels);
        if (channels.length === 0) getChannels();
      }

      if (
        emojiAction.emoji_action_scope === 'workspace' &&
        emojiAction.arguments.excludeChannels
      ) {
        set_selected_channels(emojiAction.arguments.excludeChannels);
        if (channels.length === 0) getChannels();
      }

      if (emojiAction.actionType === 'add_reply_message') {
        setReplyMessage(emojiAction.arguments.replyMessage);
        setEditorContent(emojiAction.arguments.replyMessage);

        let newEditorState;
        if (emojiAction.arguments.replyMessage) {
          newEditorState = emojiAction.arguments.replyMessage;
        } else {
          newEditorState = emojiAction.arguments.replyMessage;
        }
        setEditorState(newEditorState);
      }
    }

    if (
      emojiAction &&
      (emojiAction.actionType === 'add_to_confluence' ||
        emojiAction.actionType === 'search_confluence') &&
      emojiAction.arguments &&
      emojiAction.arguments.space
    )
      set_selectedSpace(emojiAction.arguments.space);
    if (
      emojiAction &&
      emojiAction.actionType === 'search_confluence' &&
      emojiAction.arguments &&
      emojiAction.arguments.searchSpaces
    )
      set_selectedSearchSpaces(emojiAction.arguments.searchSpaces);
  };

  const onUsingChannelDefaultsChange = (e) => {
    set_useChannelDefaults(e.target.checked);
    if (e.target.checked) {
      set_creationDefaultProject(null);
      set_createRequestDefaultProject(null);
      set_creationDefaultIssueType(null);
      set_createRequestDefaultRequestType(null);
      set_fieldDefaults({});
      set_fieldDefaultsModalVisible(null);
    }
  };

  const onupdateActionChange = (updateAction) => {
    set_updateAction(updateAction);
    set_fieldDefaults({});
    set_creationDefaultProject(null);
    set_creationDefaultIssueType(null);
  };

  const onCreationDefaultProjectChange = ({ value, data }) => {
    set_creationDefaultProject(data.project);
    set_issueLoading(true);
    set_projectError(false);
    set_fieldDefaults({});
    getProjectIssues({ project_id: data.project.id });
  };

  const onCreateRequestDefaultProjectChange = ({ value, data }) => {
    set_createRequestDefaultProject(data.project);
    set_requestTypeLoading(true);
    set_requestProjectError(false);
    set_fieldDefaults({});
    getProjectRequestTypes({ project_id: data.project.id });
  };

  const getProjectIssues = async ({ project_id, dont_set_issutype }) => {
    const issuesRes = await getIssues(wId, project_id);
    if (issuesRes && issuesRes.data && issuesRes.data.success) {
      set_issueLoading(false);
      if (issuesRes.data.issueTypes && issuesRes.data.issueTypes.length > 0) {
        if (!dont_set_issutype) {
          set_creationDefaultIssueType(issuesRes.data.issueTypes[0]);
        }
        set_issuetypeError(false);
      }
    }
  };

  const getProjectRequestTypes = async ({
    project_id,
    dont_set_requestType,
  }) => {
    const requestTypeRes = await getIssues(wId, project_id, true, true);
    if (requestTypeRes && requestTypeRes.data && requestTypeRes.data.success) {
      set_requestTypeLoading(false);
      if (
        requestTypeRes.data.issueTypes &&
        requestTypeRes.data.issueTypes.length > 0
      ) {
        if (!dont_set_requestType) {
          set_createRequestDefaultRequestType(
            requestTypeRes.data.issueTypes[0]
          );
        }
        set_requestTypeError(false);
      }
    }
  };

  const onCreationDefaultIssueTypeChange = ({ value, data }) => {
    set_creationDefaultIssueType(data.issue);
    set_issuetypeError(false);
    set_fieldDefaults({});
  };

  const onCreationDefaultRequestTypeChange = ({ value, data }) => {
    set_createRequestDefaultRequestType(data.requestType);
    set_requestTypeError(false);
    set_fieldDefaults({});
  };

  const onSpaceChange = ({ value, data }) => {
    if (data && data.space) set_selectedSpace(data.space);
    else set_selectedSpace(null);
    // set_spaceError(false);
    set_fieldDefaults({});
  };

  const onSearchSpacesChangeChange = ({ value, data }) => {
    set_selectedSearchSpaces(data);
    set_fieldDefaults({});
  };

  const createCommand = () => {
    set_isCreating(true);
    let actionType;
    if (isJiraProductsEnabled && jiraSkill_linked) actionType = 'create';
    else if (isWikiEnabled && wikiSKill_linked)
      actionType = 'add_to_confluence';

    set_actionType(actionType);
    getRequiredData({ actionType });
    if (!isAdmin) set_emoji_action_scope('personal');
  };

  const setActionType = (value) => {
    set_actionType(value);
    set_emojiError(false);
    set_emojiAlreadyUsedError(false);
    set_channelAlreadyUsedforSameEmojiError(false);
    set_purposeError(false);
    set_channelsError(false);
    set_projectError(false);
    set_issuetypeError(false);
    // set_spaceError(false);
    set_fieldDefaultsError(false);
    set_useChannelDefaults(false);
    set_creationDefaultProject(null);
    set_creationDefaultIssueType(null);
    set_fieldDefaults({});
    setEditorErrorMessage('');
  };

  const setCreationFormMode = ({ target: { value } }) => {
    set_creationFormMode(value);
  };

  const handleCustomFilterModalOk = () => {
    set_fieldDefaultsModalVisible(false);
    set_fieldDefaults(
      selectedActionForUpadate
        ? (selectedActionForUpadate.arguments &&
          selectedActionForUpadate.arguments.fieldDefaults) ||
        {}
        : {}
    );

  };

  const handlePurposeChange = (value) => {
    // value = value.charAt(0).toUpperCase() + value.slice(1);
    set_purpose(value);
    set_purposeError(false);
  };

  const createNewEmojiAction = () => {
    let error = false;

    // if (!selectedEmoji) {
    //   set_emojiError(true);
    //   error = true;
    // } else {
    //   const emojiAlreadyUsed = emojiActions.find(
    //     (action) => action.emoji.name === selectedEmoji && (selectedActionForUpadate ? action._id !== selectedActionForUpadate._id : true)
    //   );
    //   if (emojiAlreadyUsed) {
    //     set_emojiAlreadyUsedError(true);
    //     error = true;
    //   }

    //   // if (
    //   //   jiraSkill && jiraSkill.skill_metadata && jiraSkill.skill_metadata.creationEmoji
    //   //     ? jiraSkill.skill_metadata.creationEmoji.name === selectedEmoji
    //   //     : selectedEmoji === ":ticket:"
    //   // ) {
    //   //   set_emojiAlreadyUsedError(true);
    //   //   error = true;
    //   // }
    // }

    if (!selectedEmoji) {
      set_emojiError(true);
      error = true;
    } else {
      if (emoji_action_scope === 'channel') {
        let allEmojiActionChannels = [];
        emojiActions.forEach((action) => {
          if (
            (selectedActionForUpadate
              ? action._id !== selectedActionForUpadate._id
              : true) &&
            action.emoji_action_scope === 'channel' &&
            action.emoji.name === selectedEmoji &&
            action.arguments.channels
          )
            allEmojiActionChannels = [
              ...allEmojiActionChannels,
              ...action.arguments.channels,
            ];
        });
        const channelExists = selected_channels.some((r) =>
          allEmojiActionChannels.includes(r)
        );
        if (channelExists) {
          set_channelAlreadyUsedforSameEmojiError(true);
          error = true;
        }
      } else {
        const emojiAlreadyUsed = emojiActions.find(
          (action) =>
            action.emoji.name === selectedEmoji &&
            action.emoji_action_scope === emoji_action_scope &&
            (selectedActionForUpadate
              ? action._id !== selectedActionForUpadate._id
              : true)
        );
        if (emojiAlreadyUsed) {
          set_emojiAlreadyUsedError(true);
          error = true;
        }
      }
    }

    if (!purpose || (purpose && !purpose.trim())) {
      set_purposeError(true);
      error = true;
    }
    if (
      actionType === 'create' &&
      !useChannelDefaults &&
      !creationDefaultProject
    ) {
      set_projectError(true);
      error = true;
    }
    if (
      actionType === 'create' &&
      !useChannelDefaults &&
      !creationDefaultIssueType
    ) {
      set_issuetypeError(true);
      error = true;
    }

    if (
      actionType === 'update' &&
      updateAction === 'update' &&
      creationDefaultProject &&
      !creationDefaultIssueType
    ) {
      set_issuetypeError(true);
      error = true;
    }

    if (
      actionType === 'create_request' &&
      !useChannelDefaults &&
      !createRequestDefaultProject
    ) {
      set_requestProjectError(true);
      error = true;
    }
    if (
      actionType === 'create_request' &&
      !useChannelDefaults &&
      !createRequestDefaultRequestType
    ) {
      set_requestTypeError(true);
      error = true;
    }

    if (emoji_action_scope === 'channel' && selected_channels.length === 0) {
      set_channelsError(true);
      error = true;
    }

    // if (actionType === "search_confluence" && !selectedSpace) {
    //   set_spaceError(true);
    //   error = true;
    // }

    if (
      actionType === 'update' &&
      updateAction === 'update' &&
      Object.keys(fieldDefaults).length === 0
    ) {
      set_fieldDefaultsError(true);
      error = true;
    }

    if (actionType === 'add_reply_message') {
      const plainText = editorState;
      if (!plainText) {
        setEditorErrorMessage('Message is required');
        error = true;
      }
    }

    if (!error) {
      set_apiLodaing(true);
      let data = {
        workspace_id: wId,
        emoji_action_scope,
        emoji: {
          name: selectedEmoji,
          emoji: emojis[selectedEmoji],
        },
        purpose: purpose.trim(),
        actionType,
        arguments: {
          fieldDefaults,
        },
        team_id: team.id,
        disabled: false,
      };

      if (
        actionType === 'update' &&
        updateAction === 'update' &&
        creationDefaultProject
      ) {
        /* THIS IS A QUCIK FIX TO GET THE META DATA OF THE FIELDS, SHOULD BE HANDLED PROPERLY IN THE FEATURE, HAC-1981 */
        let fieldsMeta = [];
        if (fieldsMetaData)
          fieldsMetaData.forEach((field) => {
            if (
              field.key === 'reporter' ||
              field.key === 'labels' ||
              field.key === 'assignee'
            ) {
            } else {
              if (fieldDefaults[field.key]) fieldsMeta.push(field);
            }
          });
        data.arguments.fieldsMeta = fieldsMeta;
      }

      if (actionType === 'update') {
        data.arguments.type = updateAction;
        data.arguments.project = creationDefaultProject;
        data.arguments.issueType = creationDefaultIssueType;
        if (updateAction === 'status_to_done' && selectedResolution)
          data.arguments.resolution = selectedResolution;
      } else if (actionType === 'add_to_confluence') {
        if (selectedSpace) data.arguments.space = selectedSpace;
      } else if (actionType === 'search_confluence') {
        if (selectedSearchSpaces)
          data.arguments.searchSpaces = selectedSearchSpaces;
      } else if (actionType === 'add_comment') {
        delete data.arguments;
      } else if (actionType === 'create_request') {
        data.arguments.useChannelDefaults = useChannelDefaults;
        data.arguments.project = createRequestDefaultProject;
        data.arguments.requestType = createRequestDefaultRequestType;
        data.arguments.creationFormMode = creationFormMode;
      } else if (actionType === 'add_reply_message') {
        const entityRegex = /&[A-Za-z]+;/g; // Regex to remove HTML entities such as &nbsp;
        const newlineRegex = /[\n\t]/g; // Remove newline and tab characters
        data.arguments.replyMessage = replyMessage
          .replace(entityRegex, '')
          .replace(newlineRegex, '');
        data.arguments.replyMessageEditorContent = editorContent;
      } else {
        data.arguments.useChannelDefaults = useChannelDefaults;
        data.arguments.project = creationDefaultProject;
        data.arguments.issueType = creationDefaultIssueType;
        data.arguments.creationFormMode = creationFormMode;
      }

      if (emoji_action_scope === 'channel' && selected_channels.length > 0) {
        if (!data.arguments) {
          data.arguments = {};
        }
        data.arguments.channels = selected_channels;
      }

      if (emoji_action_scope === 'workspace' && selected_channels.length > 0) {
        data.arguments.excludeChannels = selected_channels;
      }

      if (selectedActionForUpadate) {
        updateEmojiAction(wId, selectedActionForUpadate._id, data).then(
          (res) => {
            if (res.success) {
              set_emojiActions(
                emojiActions.map((action) => {
                  if (action._id === selectedActionForUpadate._id)
                    return res.emojiAction;
                  else return action;
                })
              );
              resetStates();
            }
          }
        );
      } else {
        createEmojiAction(wId, data).then((res) => {
          if (res.success) {
            set_emojiActions([...emojiActions, res.emojiAction]);
            resetStates();
          }
        });
      }
    }
  };

  let timeout = 0;
  const onSearch = (val) => {
    if (
      jiraSkill &&
      jiraSkill.skill_metadata &&
      jiraSkill.skill_metadata.metadata &&
      (jiraSkill.skill_metadata.metadata.server_type === 'jira_cloud_oauth' ||
        jiraSkill.skill_metadata.metadata.server_type === 'jira_cloud')
    ) {
      let query = `query=${val || ''}`;
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        dropDownSearchJiraProjects(props.match.params.wId, `?query=${query}`);
      }, 300);
    }
  };

  const updateAutoCreateEmoji = async (emoji_name) => {
    let data = {
      creationEmoji: {
        name: emoji_name,
        emoji: emojis[emoji_name],
      },
    };
    jiraSkill.skill_metadata.creationEmoji = { name: emoji_name };
    // let response = await axios.patch(`/bot/api/workspace/${props.match.params.wId}/skill/${jiraSkill.skill_metadata._id}`, data);
    let response = await axios.patch(
      `/bot/api/w/${props.match.params.wId}/skill/${jiraSkill.skill_metadata._id}`,
      data
    );
    if (response) {
      /* emoji wasn't updating in the ui for some reason */
      // if (response.data && response.data.success && response.data.skill) {
      //   jiraSkill.skill_metadata = response.data.skill;
      // }
    }
  };

  const handleEmojiActionScopeChange = async (value) => {
    set_emoji_action_scope(value);
    set_channelsError(false);
    set_channelAlreadyUsedforSameEmojiError(false);
    if (value === 'channel' && channels.length === 0) {
      getChannels();
    }
    if (selectedActionForUpadate) {
      if (value === 'channel') {
        set_selected_channels(
          selectedActionForUpadate.arguments.channels || []
        );
      }

      if (value === 'workspace') {
        set_selected_channels(
          selectedActionForUpadate.arguments.excludeChannels || []
        );
      }
    } else {
      set_selected_channels([]);
    }
  };

  const getChannels = () => {
    if (channels.length === 0) getChannelList(wId);
  };

  const handleChannelsChange = (value) => {
    set_selected_channels(value);
    set_channelsError(false);
    set_channelAlreadyUsedforSameEmojiError(false);
  };

  const actionOptions = [
    {
      value: 'create',
      label: 'Issue create',
      disabled: !(isJiraProductsEnabled && jiraSkill_linked),
    },
    ...(helpdeskSubSkill
      ? [
        {
          value: 'create_request',
          label: 'Request create',
          disabled: !(
            isJiraProductsEnabled &&
            jiraSkill_linked &&
            helpdeskSubSkill &&
            !helpdeskSubSkill.disabled
          ),
        },
      ]
      : []),
    {
      value: 'update',
      label: 'Issue update',
      disabled: !(isJiraProductsEnabled && jiraSkill_linked),
    },
    {
      value: 'add_comment',
      label: 'Add comment',
      disabled: !(isJiraProductsEnabled && jiraSkill_linked),
    },
    ...(wikiSkill && wikiSkill.skill_metadata
      ? [
        {
          value: 'add_to_confluence',
          label: 'Add to Confluence',
          disabled: !(isWikiEnabled && wikiSKill_linked),
        },
      ]
      : []),
    ...(wikiSkill && wikiSkill.skill_metadata
      ? [
        {
          value: 'search_confluence',
          label: 'Search Confluence',
          disabled: !(isWikiEnabled && wikiSKill_linked),
        },
      ]
      : []),
    {
      value: 'add_reply_message',
      label: 'Add reply message',
      disabled: !(isJiraProductsEnabled && jiraSkill_linked),
    },
  ];

  const handleContentStateChange = (contentState) => {
    setReplyMessage(contentState);
  };

  const handleEditorStateChange = (html) => {
    const plainText = html.replace(/<[^>]+>/g, '').trim(); // Remove HTML tags
    // const { editorState } = this.state;

    if (plainText.length > maxCharacterLimit) {
      if (this.state.editorErrorMessage !== `Character limit (${maxCharacterLimit}) reached.`) {
        this.setState({ editorErrorMessage: `Character limit (${maxCharacterLimit}) reached.` });
      }
      return;
    }

    if (editorState !== html || this.state.editorErrorMessage) {
      setEditorState(html)
      setEditorErrorMessage('')

      setReplyMessage(html);
      setEditorContent(html);

      // this.setState({
      //   editorState: html,
      //   noResultMessage: html,
      //   editorErrorMessage: '',
      // });
    }
  }



  return (
    <>
      <Modal
        title='Set Field values'
        visible={fieldDefaultsModalVisible}
        // onOk={() => set_fieldDefaultsModalVisible(false)}
        // okText='Update'
        footer={[
          <Button
            key='submit'
            type='primary'
            onClick={() => set_fieldDefaultsModalVisible(false)}
          >
            Update
          </Button>,
        ]}
        // onCancel={handleCustomFilterModalOk}
        cancelButtonProps={{ background: 'red' }}
        maskClosable={false}
        closable={false}
        destroyOnClose={true}
        centered
        bodyStyle={{
          maxHeight: '70vh',
          overflowY: 'scroll',
          overflowX: 'hidden',
        }}
      >
        {jiraSkill && (
          <>
            {actionType === 'update' && !creationDefaultProject ? (
              <JiraCommonIssueFields
                skill_id={jiraSkill.skill_metadata._id}
                handleUpdateFieldDefaultsChanges={(data) => {
                  set_fieldDefaults(data);
                  set_fieldDefaultsError(false);
                }}
                // selectedActionForUpadate={selectedActionForUpadate}
                selectedActionForUpadate={{ arguments: { fieldDefaults } }}
              />
            ) : (
              <>
                {actionType === 'update' && (
                  <JiraCommonIssueFields
                    skill_id={jiraSkill.skill_metadata._id}
                    handleUpdateFieldDefaultsChanges={(data) => {
                      let temp = { ...fieldDefaults };
                      if (data.status) temp = { ...fieldDefaults, ...data };
                      else delete temp.status;
                      set_fieldDefaults(temp);
                      set_fieldDefaultsError(false);
                    }}
                    // selectedActionForUpadate={selectedActionForUpadate}
                    selectedActionForUpadate={{ arguments: { fieldDefaults } }}
                    linkedProject={
                      creationDefaultProject ? creationDefaultProject.id : null
                    }
                  />
                )}
                <JiraIssueFields
                  issues={issues}
                  linkedIssue={
                    creationDefaultIssueType
                      ? creationDefaultIssueType.value
                      : null
                  }
                  linkedProject={
                    creationDefaultProject ? creationDefaultProject.id : null
                  }
                  handleFieldDefaultsChange={(fieldDefaults) => {
                    set_fieldDefaults({
                      ...fieldDefaults[creationDefaultIssueType.value],
                    });
                    set_fieldDefaultsError(false);
                  }}
                  getFieldsMetaData={(fieldsMetaData) => {
                    /* THIS IS A QUCIK FIX TO GET THE META DATA OF THE FIELDS, SHOULD BE HANDLED PROPERLY IN THE FEATURE, HAC-1981 */
                    set_fieldsMetaData(fieldsMetaData);
                  }}
                  forEmojiAction={true}
                  // selectedActionForUpadate={selectedActionForUpadate}
                  selectedActionForUpadate={{
                    arguments: {
                      fieldDefaults,
                      project: creationDefaultProject,
                      issueType: creationDefaultIssueType,
                    },
                  }}
                  skill_id={jiraSkill.skill_metadata._id}
                // updateChannelDefaultData={this.state.updateChannelDefaultData}
                // saveChannelDefault={(data) => this.saveChannelDefault(data)}
                // channelDefault={this.props.channelDefault}
                // board={this.state.board}
                // disableEdit={currentChannelConfigs != false && !isChannelAdmin && !isWorkspaceAdimin}
                />
              </>
            )}
          </>
        )}
      </Modal>

      <Modal
        closable={false}
        visible={emojiModalView || emojiModalViewForDefaultAction}
        maskClosable={false}
        onCancel={() => {
          set_emojiModalView(false);
          set_emojiModalViewForDefaultAction(false);
        }}
        destroyOnClose={true}
      //   onOk={handleCustomFilterModalOk}
      >
        <EmojiPicker
          customEmojisFromSlack={customEmojisFromSlack}
          selectedEmoji={selectedEmoji}
          closePicker={() => {
            set_emojiModalView(false);
            set_emojiModalViewForDefaultAction(false);
          }}
          handleClick={(el) => {
            if (emojiModalViewForDefaultAction) updateAutoCreateEmoji(el.name);
            set_selectedEmoji(`${el.name}`);
            set_emojiModalView(false);
            set_emojiModalViewForDefaultAction(false);
            set_emojiError(false);
            set_emojiAlreadyUsedError(false);
            set_channelAlreadyUsedforSameEmojiError(false);
          }}
        />
      </Modal>
      <PageHeader
        // className="site-page-header"
        // onBack={() => null}
        title='Emoji Actions'
        subTitle='Add emoji to any Slack message to trigger a Troopr action'
      />
      <Content
        className='site-layout-background'
        style={{
          padding: '32px 32px 100px 32px',
          height: '100vh',
          overflow: 'auto',
        }}
      >
        {skills && skills.length > 0 ? (
          <>
            <Alert
              message='Make sure Troopr is invited to the channel for emoji actions to work'
              style={{ marginBottom: 16 }}
            />
            {!isJiraProductsEnabled && (
              <Alert
                message={`You need Troopr Projects ${helpdeskSubSkill ? 'or Troopr HelpDesk' : ''
                  } or Troopr Reports enabled to use Jira related emoji actions`}
                type='warning'
                style={{ marginBottom: 16 }}
              />
            )}
            {!jiraSkill_linked && (
              <Alert
                message='You need an active Jira connection to create Jira related emoji actions'
                type='warning'
                style={{ marginBottom: 16 }}
              />
            )}
            {isWikiEnabled === false && (
              <Alert
                message='You need Troopr Wiki enabled to use Wiki related emoji actions'
                type='warning'
                style={{ marginBottom: 16 }}
              />
            )}
            {wikiSKill_linked === false && (
              <Alert
                message='You need an active Wiki connection to create Wiki related emoji actions'
                type='warning'
                style={{ marginBottom: 16 }}
              />
            )}
            {/* {members && members.length > 0 && !isAdmin && (
              <Alert message='Only workspace admins can create or update emoji actions' type='warning' style={{ marginBottom: 16 }} />
            )} */}
            {isCreating ? (
              <>
                <Card
                  title={
                    <>
                      <Button
                        onClick={() => resetStates()}
                        style={{ marginRight: 8 }}
                      >
                        Back
                      </Button>
                      <Text strong>
                        {selectedActionForUpadate
                          ? 'Update emoji action'
                          : 'Creating new emoji action'}
                      </Text>
                    </>
                  }
                >
                  <div
                    style={{
                      display: 'flex',
                      flexFlow: 'column',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        marginBottom: 16,
                        alignItems: 'center',
                      }}
                    >
                      <div style={{ width: 210 }}>
                        <div style={{ float: 'right', marginRight: 8 }}>
                          <Text strong>Emoji:</Text>
                        </div>
                      </div>
                      <div>
                        {emojis[selectedEmoji] ||
                          (customEmojisFromSlack[selectedEmoji] ? (
                            <img
                              style={{ width: '22px', height: '22px' }}
                              src={customEmojisFromSlack[selectedEmoji]}
                              alt=''
                            />
                          ) : (
                            ''
                          ))}{' '}
                        {selectedEmoji}
                        <Button
                          style={selectedEmoji ? { marginLeft: 16 } : {}}
                          onClick={() => set_emojiModalView(true)}
                        >
                          Pick Emoji
                        </Button>
                      </div>
                    </div>
                    {emojiError && (
                      <Text
                        type='danger'
                        style={{ marginLeft: '200px', marginTop: '-16px' }}
                      >
                        * Please pick a emoji
                      </Text>
                    )}
                    {emojiAlreadyUsedError && (
                      <Text
                        type='danger'
                        style={{ marginLeft: '200px', marginTop: '-16px' }}
                      >
                        * Emoji action already configured for this emoji. Please
                        pick another emoji
                      </Text>
                    )}
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        marginBottom: 8,
                        alignItems: 'center',
                      }}
                    >
                      <div style={{ width: 210 }}>
                        <div style={{ float: 'right', marginRight: 8 }}>
                          <Text strong>Purpose:</Text>
                        </div>
                      </div>

                      <div>
                        <Input
                          onChange={(e) => handlePurposeChange(e.target.value)}
                          value={purpose}
                          placeholder='Convert the message into Jira issue'
                          style={{ width: 500 }}
                        />
                      </div>
                    </div>
                    {purposeError && (
                      <Text
                        type='danger'
                        style={{ marginLeft: '200px', marginTop: '-9px' }}
                      >
                        * Please enter purpose
                      </Text>
                    )}
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        marginBottom: 8,
                        alignItems: 'center',
                      }}
                    >
                      <div style={{ width: 210 }}>
                        <div style={{ float: 'right', marginRight: 8 }}>
                          <Text strong>Scope:</Text>
                        </div>
                      </div>

                      <div>
                        <Radio.Group
                          options={[
                            {
                              label: 'Workspace',
                              value: 'workspace',
                              disabled: isAdmin ? false : true,
                            },
                            { label: 'Personal', value: 'personal' },
                            {
                              label: 'Channel',
                              value: 'channel',
                              disabled: isAdmin ? false : true,
                            },
                          ]}
                          value={emoji_action_scope}
                          onChange={(e) =>
                            handleEmojiActionScopeChange(e.target.value)
                          }
                        />
                      </div>
                    </div>
                    {(emoji_action_scope === 'channel' ||
                      emoji_action_scope === 'workspace') && (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: 'row',
                            marginBottom: 8,
                            alignItems: 'center',
                          }}
                        >
                          <div style={{ width: 210 }}>
                            <div style={{ float: 'right', marginRight: 8 }}>
                              <Text strong>
                                {emoji_action_scope === 'workspace'
                                  ? 'Exclude channels'
                                  : 'Channels'}
                                :
                              </Text>
                            </div>
                          </div>

                          <div>
                            <Select
                              style={{ width: 400 }}
                              mode='multiple'
                              placeholder={
                                emoji_action_scope === 'workspace'
                                  ? 'Select channels to exclude from workspace'
                                  : 'Select channels'
                              }
                              loading={channels.length === 0}
                              onChange={(value) => handleChannelsChange(value)}
                              value={selected_channels}
                              filterOption={(input, option) =>
                                option.props.children
                                  .toLowerCase()
                                  .indexOf(input.toLowerCase()) >= 0
                              }
                            >
                              {channels.map((channel) => (
                                <Option
                                  key={channel.id}
                                  value={channel.id}
                                  channel={channel}
                                >
                                  {channel.name}
                                </Option>
                              ))}
                            </Select>
                            {channelsError && (
                              <>
                                <br />
                                <Text type='danger'>
                                  * Please select channels
                                </Text>
                              </>
                            )}
                            {channelAlreadyUsedforSameEmojiError && (
                              <>
                                <br />
                                <Text type='danger'>
                                  * Selected channel already configured for same
                                  emoji
                                </Text>
                              </>
                            )}
                          </div>
                        </div>
                      )}
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alginItems: 'center',
                      }}
                    >
                      <div style={{ width: 210 }}>
                        <div style={{ float: 'right', marginRight: 8 }}>
                          <Text strong>Emoji action type:</Text>
                        </div>
                      </div>

                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                        }}
                      >
                        <div>
                          <Select
                            value={actionType}
                            style={{ width: 200 }}
                            onChange={(value, data) => {
                              setActionType(value);
                              getRequiredData({ actionType: value });
                            }}
                          >
                            {actionOptions.map((option) => (
                              <Option
                                key={option.value}
                                value={option.value}
                                disabled={option.disabled}
                              >
                                {option.label}
                              </Option>
                            ))}
                          </Select>
                          {/* <Radio.Group
                            options={[
                              { label: "Issue create", value: "create", disabled: !(isJiraProductsEnabled && jiraSkill_linked) },
                              { label: "Issue update", value: "update", disabled: !(isJiraProductsEnabled && jiraSkill_linked) },
                              {
                                label: "Add to Confluence",
                                value: "add_to_confluence",
                                disabled: !(isWikiEnabled && wikiSKill_linked),
                              },
                            ]}
                            value={actionType}
                            onChange={setActionType}
                            // optionType="button"
                            // buttonStyle="solid"
                          /> */}
                        </div>
                        <div style={{ width: 500 }}>
                          <Text type='secondary'>
                            {actionType === 'create' ? (
                              'Convert the Slack message into a Jira issue.'
                            ) : actionType === 'update' ? (
                              <>
                                Update the Jira issue corresponding to the Slack
                                message.{' '}
                                <a
                                  onClick={() =>
                                    Modal.info({
                                      title: 'Emoji issue update action',
                                      content: (
                                        <div>
                                          <Text>
                                            Troopr emoji update action can be
                                            used on Troopr issue messages. It
                                            can also be used in user messages
                                            that were converted to Jira issue by
                                            Troopr.
                                            {/* Troopr emoji update action can be used on Troopr issue or request messages. It can also be used in
                                                  user messages that were converted to Jira issue or request by Troopr. */}
                                          </Text>
                                        </div>
                                      ),
                                      onOk() { },
                                    })
                                  }
                                >
                                  Where to use?
                                </a>
                              </>
                            ) : actionType === 'add_to_confluence' ? (
                              <>
                                Create or update a Confluence page with the
                                Slack message.{' '}
                                <a
                                  onClick={() =>
                                    Modal.info({
                                      title: 'Emoji Add to Confluence action',
                                      content: (
                                        <div>
                                          <Text>
                                            Troopr emoji "Add to Confluence"
                                            action can be used on any Slack
                                            message. This action will show a
                                            private "Add to Confluence" button
                                            to the action taker. Clicking on the
                                            button will open a form with the
                                            Slack message as page title
                                            (truncated) and page content and
                                            keywords from the message as page
                                            label(s).
                                          </Text>
                                        </div>
                                      ),
                                      onOk() { },
                                    })
                                  }
                                >
                                  How does it work?
                                </a>
                              </>
                            ) : actionType === 'add_comment' ? (
                              'Add the Slack message as comment to an existing Jira issue'
                            ) : actionType === 'create_request' ? (
                              'Convert the Slack message into a Jira Service Management request.'
                            ) : actionType === 'search_confluence' ? (
                              'Search matching Confluence pages for the Slack message.'
                            ) : actionType === 'add_reply_message' ? (
                              'Sends a reply message for the Slack message.'
                            ) : (
                              ''
                            )}
                          </Text>
                        </div>
                      </div>
                    </div>

                    <div style={{ display: 'flex', flexDirection: 'column' }}>
                      {actionType === 'create' ? (
                        <>
                          <Divider />
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'flex-start',
                              marginBottom: '8px',
                            }}
                          >
                            <div style={{ width: 210 }}>
                              <div style={{ float: 'right', marginRight: 8 }}>
                                <Text strong>Issue creation details:</Text>
                              </div>
                            </div>

                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                              }}
                            >
                              <div style={{ marginBottom: 8 }}>
                                <Checkbox
                                  checked={useChannelDefaults}
                                  onChange={onUsingChannelDefaultsChange}
                                >
                                  Use Channel defaults
                                </Checkbox>
                                <a
                                  onClick={() =>
                                    Modal.info({
                                      title: 'Using channel defaults',
                                      content: (
                                        <div>
                                          <Text>
                                            Troopr will use the default project,
                                            issuetype and other field defaults
                                            that are set up in the channel where
                                            emoji is used
                                          </Text>
                                        </div>
                                      ),
                                      onOk() { },
                                    })
                                  }
                                >
                                  Whats this?
                                </a>
                              </div>

                              {useChannelDefaults ? (
                                ''
                              ) : (
                                <>
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'row',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <div>
                                      <Select
                                        style={{ width: 200, marginRight: 8 }}
                                        placeholder='Select Project'
                                        value={
                                          (creationDefaultProject &&
                                            creationDefaultProject.id) ||
                                          null
                                        }
                                        onChange={(value, data) =>
                                          onCreationDefaultProjectChange({
                                            value,
                                            data,
                                          })
                                        }
                                        loading={projects.length === 0}
                                        filterOption={(input, option) =>
                                          option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                        }
                                        showSearch
                                        onSearch={onSearch}
                                      >
                                        {projects.map((project) => (
                                          <Option
                                            key={project.id}
                                            value={project.id}
                                            project={project}
                                          >
                                            {project.name + ` (${project.key})`}
                                          </Option>
                                        ))}
                                      </Select>
                                    </div>
                                    <div>
                                      <Select
                                        style={{ width: 200, marginRight: 8 }}
                                        placeholder='Select IssueType'
                                        value={
                                          (creationDefaultIssueType &&
                                            creationDefaultIssueType.value) ||
                                          null
                                        }
                                        onChange={(value, data) =>
                                          onCreationDefaultIssueTypeChange({
                                            value,
                                            data,
                                          })
                                        }
                                        loading={issueLoading}
                                        filterOption={(input, option) =>
                                          option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                        }
                                        showSearch
                                      >
                                        {issues.map((issue) => (
                                          <Option
                                            key={issue.value}
                                            value={issue.value}
                                            issue={issue}
                                          >
                                            {issue.text}
                                          </Option>
                                        ))}
                                      </Select>
                                    </div>
                                    {creationDefaultProject &&
                                      creationDefaultIssueType && (
                                        <div>
                                          <Text style={{ marginRight: 4 }}>
                                            {Object.keys(fieldDefaults).length >
                                              0
                                              ? `${Object.keys(fieldDefaults)
                                                .length
                                              } field value(s) set`
                                              : 'No field values set'}
                                          </Text>
                                          <a
                                            onClick={() =>
                                              set_fieldDefaultsModalVisible(
                                                true
                                              )
                                            }
                                          >
                                            Update
                                          </a>
                                          <Text> | </Text>
                                          <a
                                            onClick={() => {
                                              set_creationDefaultProject(null);
                                              set_creationDefaultIssueType(
                                                null
                                              );
                                              set_fieldDefaults({});
                                            }}
                                          >
                                            Clear
                                          </a>
                                        </div>
                                      )}
                                  </div>
                                  {projectError && (
                                    <Text type='danger'>
                                      * Please select project
                                    </Text>
                                  )}
                                  {issuetypeError && (
                                    <Text
                                      type='danger'
                                      style={{
                                        marginLeft: '210px',
                                        marginTop: projectError ? '-22px' : '',
                                      }}
                                    >
                                      * Please select issuetype
                                    </Text>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'flex-start',
                            }}
                          >
                            <div style={{ width: 210 }}>
                              <div style={{ float: 'right', marginRight: 8 }}>
                                <Text strong>Creation form:</Text>
                              </div>
                            </div>

                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                              }}
                            >
                              <div style={{ marginBottom: 4 }}>
                                <Radio.Group
                                  value={creationFormMode}
                                  onChange={setCreationFormMode}
                                >
                                  <Radio value='always'>Always</Radio>
                                  <Radio value='onFail'>On Failure</Radio>
                                  <Radio value='never'>Never</Radio>
                                </Radio.Group>
                              </div>
                              <div>
                                <Text type='secondary'>
                                  {creationFormMode === 'always' ? (
                                    'Always show issue creation form button'
                                  ) : creationFormMode === 'onFail' ? (
                                    <>
                                      Show issue creation form button only when
                                      issue could not be created automatically
                                      <br />
                                      <Text type='warning'>
                                        Automatic issue creation will work only
                                        when "summary" is the only mandatory
                                        field in the default issue type.
                                      </Text>
                                    </>
                                  ) : (
                                    <>
                                      Never show issue creation form button.
                                      When issue could not be created, fail
                                      silently.
                                      <br />
                                      <Text type='warning'>
                                        Automatic issue creation will work only
                                        when "summary" is the only mandatory
                                        field in the default issue type.
                                      </Text>
                                    </>
                                  )}
                                </Text>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : actionType === 'create_request' ? (
                        <>
                          <Divider />
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'flex-start',
                              marginBottom: '8px',
                            }}
                          >
                            <div style={{ width: 210 }}>
                              <div style={{ float: 'right', marginRight: 8 }}>
                                <Text strong>Request creation details:</Text>
                              </div>
                            </div>

                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                              }}
                            >
                              <div style={{ marginBottom: 8 }}>
                                <Checkbox
                                  checked={useChannelDefaults}
                                  onChange={onUsingChannelDefaultsChange}
                                >
                                  Use Channel defaults
                                </Checkbox>
                                <a
                                  onClick={() =>
                                    Modal.info({
                                      title: 'Using channel defaults',
                                      content: (
                                        <div>
                                          <Text>
                                            Troopr will use the default project,
                                            request type that are set up in the
                                            channel where emoji is used
                                          </Text>
                                        </div>
                                      ),
                                      onOk() { },
                                    })
                                  }
                                >
                                  Whats this?
                                </a>
                              </div>
                              {useChannelDefaults ? (
                                ''
                              ) : (
                                <>
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'row',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <div>
                                      <Select
                                        style={{ width: 200, marginRight: 8 }}
                                        placeholder='Select Project'
                                        value={
                                          (createRequestDefaultProject &&
                                            createRequestDefaultProject.id) ||
                                          null
                                        }
                                        onChange={(value, data) =>
                                          onCreateRequestDefaultProjectChange({
                                            value,
                                            data,
                                          })
                                        }
                                        loading={jsd_projects.length === 0}
                                        filterOption={(input, option) =>
                                          option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                        }
                                        showSearch
                                        onSearch={onSearch}
                                      >
                                        {jsd_projects.map((project) => (
                                          <Option
                                            key={project.id}
                                            value={project.id}
                                            project={project}
                                          >
                                            {project.projectName +
                                              ` (${project.projectKey})`}
                                          </Option>
                                        ))}
                                      </Select>
                                    </div>
                                    <div>
                                      <Select
                                        style={{ width: 200, marginRight: 8 }}
                                        placeholder='Select RequestType'
                                        value={
                                          (createRequestDefaultRequestType &&
                                            createRequestDefaultRequestType.value) ||
                                          null
                                        }
                                        onChange={(value, data) =>
                                          onCreationDefaultRequestTypeChange({
                                            value,
                                            data,
                                          })
                                        }
                                        loading={requestTypeLoading}
                                        filterOption={(input, option) =>
                                          option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                        }
                                        showSearch
                                      >
                                        {requestTypes.map((requestType) => (
                                          <Option
                                            key={requestType.value}
                                            value={requestType.value}
                                            requestType={requestType}
                                          >
                                            {requestType.text}
                                          </Option>
                                        ))}
                                      </Select>
                                    </div>
                                  </div>
                                  {requestProjectError && (
                                    <Text type='danger'>
                                      * Please select project
                                    </Text>
                                  )}
                                  {requestTypeError && (
                                    <Text
                                      type='danger'
                                      style={{
                                        marginLeft: '210px',
                                        marginTop: requestProjectError
                                          ? '-22px'
                                          : '',
                                      }}
                                    >
                                      * Please select request type
                                    </Text>
                                  )}
                                </>
                              )}
                            </div>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'flex-start',
                            }}
                          >
                            <div style={{ width: 210 }}>
                              <div style={{ float: 'right', marginRight: 8 }}>
                                <Text strong>Creation form:</Text>
                              </div>
                            </div>

                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                              }}
                            >
                              <div style={{ marginBottom: 4 }}>
                                <Radio.Group
                                  value={creationFormMode}
                                  onChange={setCreationFormMode}
                                >
                                  <Radio value='always'>Always</Radio>
                                  <Radio value='onFail'>On Failure</Radio>
                                  <Radio value='never'>Never</Radio>
                                </Radio.Group>
                              </div>
                              <div>
                                <Text type='secondary'>
                                  {creationFormMode === 'always' ? (
                                    'Always show request creation form button'
                                  ) : creationFormMode === 'onFail' ? (
                                    <>
                                      Show request creation form button only
                                      when request could not be created
                                      automatically
                                      <br />
                                      <Text type='warning'>
                                        Automatic request creation will work
                                        only when "summary" is the only
                                        mandatory field in the default request
                                        type.
                                      </Text>
                                    </>
                                  ) : (
                                    <>
                                      Never show request creation form button.
                                      When request could not be created, fail
                                      silently.
                                      <br />
                                      <Text type='warning'>
                                        Automatic request creation will work
                                        only when "summary" is the only
                                        mandatory field in the default request
                                        type.
                                      </Text>
                                    </>
                                  )}
                                </Text>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : actionType === 'update' ? (
                        <>
                          <Divider />
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'flex-start',
                            }}
                          >
                            <div style={{ width: 210 }}>
                              <div style={{ float: 'right', marginRight: 8 }}>
                                <Text strong>Issue update details:</Text>
                              </div>
                            </div>

                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                              }}
                            >
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                  marginBottom: 8,
                                }}
                              >
                                <div style={{ marginRight: 16 }}>
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'column',
                                    }}
                                  >
                                    <div>
                                      <Select
                                        style={{ width: 200 }}
                                        value={updateAction}
                                        onChange={onupdateActionChange}
                                      >
                                        <Option value='update'>
                                          Update Field(s)
                                        </Option>
                                        <Option value='assignme'>
                                          Assign to me
                                        </Option>
                                        <Option value='status_to_done'>
                                          Mark as Done
                                        </Option>
                                        <Option value='watch'>
                                          Start Watching
                                        </Option>
                                      </Select>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              {updateAction === 'update' && (
                                <>
                                  <div
                                    style={{
                                      display: 'flex',
                                      flexDirection: 'row',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <div>
                                      <Select
                                        style={{ width: 200, marginRight: 8 }}
                                        placeholder='Select Project'
                                        value={
                                          (creationDefaultProject &&
                                            creationDefaultProject.id) ||
                                          'all_projects'
                                        }
                                        onChange={(value, data) => {
                                          set_fieldDefaultsError(false);
                                          if (value === 'all_projects') {
                                            set_fieldDefaults({});
                                            set_creationDefaultProject(null);
                                            set_creationDefaultIssueType(null);
                                          } else
                                            onCreationDefaultProjectChange({
                                              value,
                                              data,
                                            });
                                        }}
                                        loading={projects.length === 0}
                                        filterOption={(input, option) =>
                                          option.props.children
                                            .toLowerCase()
                                            .indexOf(input.toLowerCase()) >= 0
                                        }
                                        showSearch
                                        onSearch={onSearch}
                                      >
                                        <Option
                                          key={'all_projects'}
                                          value={'all_projects'}
                                        >
                                          All Projects
                                        </Option>
                                        {projects.map((project) => (
                                          <Option
                                            key={project.id}
                                            value={project.id}
                                            project={project}
                                          >
                                            {project.name + ` (${project.key})`}
                                          </Option>
                                        ))}
                                      </Select>
                                    </div>
                                    {creationDefaultProject && (
                                      <div>
                                        <Select
                                          style={{ width: 200, marginRight: 8 }}
                                          placeholder='Select IssueType'
                                          value={
                                            (creationDefaultIssueType &&
                                              creationDefaultIssueType.value) ||
                                            null
                                          }
                                          onChange={(value, data) =>
                                            onCreationDefaultIssueTypeChange({
                                              value,
                                              data,
                                            })
                                          }
                                          loading={issueLoading}
                                          filterOption={(input, option) =>
                                            option.props.children
                                              .toLowerCase()
                                              .indexOf(input.toLowerCase()) >= 0
                                          }
                                          showSearch
                                        >
                                          {issues.map((issue) => (
                                            <Option
                                              key={issue.value}
                                              value={issue.value}
                                              issue={issue}
                                            >
                                              {issue.text}
                                            </Option>
                                          ))}
                                        </Select>
                                      </div>
                                    )}
                                    {creationDefaultProject &&
                                      creationDefaultIssueType ? (
                                      <div>
                                        <Text style={{ marginRight: 4 }}>
                                          {Object.keys(fieldDefaults).length > 0
                                            ? `${Object.keys(fieldDefaults)
                                              .length
                                            } field value(s) set`
                                            : 'No field values set'}
                                        </Text>
                                        <a
                                          onClick={() =>
                                            set_fieldDefaultsModalVisible(true)
                                          }
                                        >
                                          Update
                                        </a>
                                        <Text> | </Text>
                                        <a
                                          onClick={() => {
                                            set_creationDefaultProject(null);
                                            set_creationDefaultIssueType(null);
                                            set_fieldDefaults({});
                                            set_fieldDefaultsError(false);
                                          }}
                                        >
                                          Clear
                                        </a>
                                      </div>
                                    ) : (
                                      <div
                                        style={{
                                          display: 'flex',
                                          flexDirection: 'row',
                                          alignItems: 'center',
                                        }}
                                      >
                                        <div>
                                          <Text style={{ marginRight: 4 }}>
                                            {Object.keys(fieldDefaults).length >
                                              0
                                              ? `${Object.keys(fieldDefaults)
                                                .length
                                              } field value(s) set`
                                              : 'No field values set'}
                                          </Text>
                                          <a
                                            onClick={() =>
                                              set_fieldDefaultsModalVisible(
                                                true
                                              )
                                            }
                                          >
                                            Update
                                          </a>
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                  {projectError && (
                                    <Text type='danger'>
                                      * Please select project
                                    </Text>
                                  )}
                                  {issuetypeError && (
                                    <Text
                                      type='danger'
                                      style={{
                                        marginLeft: '210px',
                                        marginTop: projectError ? '-22px' : '',
                                      }}
                                    >
                                      * Please select issuetype
                                    </Text>
                                  )}
                                  {fieldDefaultsError && (
                                    <div
                                      style={{
                                        marginLeft: '410px',
                                        marginTop: issuetypeError
                                          ? '-22px'
                                          : creationDefaultProject
                                            ? ''
                                            : '-26px',
                                      }}
                                    >
                                      <Text
                                        type='danger'
                                        style={{ marginLeft: 8 }}
                                      >
                                        * Please set field defaults
                                      </Text>
                                    </div>
                                  )}
                                  <Text type='secondary'>
                                    👆Choose a project and issue type to fetch
                                    corresponding list of fields.
                                    <br /> Troopr will attempt to update the
                                    field values irrespective of the project and
                                    issue type of the issue.
                                  </Text>
                                </>
                              )}
                            </div>
                          </div>
                          {updateAction === 'status_to_done' && (
                            <>
                              <div
                                style={{
                                  display: 'flex',
                                  flexDirection: 'row',
                                  alignItems: 'center',
                                }}
                              >
                                <div style={{ width: 210 }}>
                                  <div
                                    style={{ float: 'right', marginRight: 8 }}
                                  >
                                    <Text strong>Resolution:</Text>
                                  </div>
                                </div>
                                <div>
                                  <Select
                                    // allowClear
                                    placeholder='Select Resolution'
                                    style={{ width: 200 }}
                                    loading={resolutions.length === 0}
                                    onChange={(value, data) =>
                                      set_selectedResolution(
                                        data && data.resolution
                                          ? data.resolution
                                          : null
                                      )
                                    }
                                    value={
                                      selectedResolution
                                        ? selectedResolution.id
                                        : 'Done'
                                    }
                                    filterOption={(input, option) =>
                                      option.props.children
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    }
                                    showSearch
                                  >
                                    {resolutions.map((resolution) => (
                                      <Option
                                        key={resolution.id}
                                        value={resolution.id}
                                        resolution={resolution}
                                      >
                                        {resolution.name}
                                      </Option>
                                    ))}
                                  </Select>
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      ) : actionType === 'add_to_confluence' ? (
                        <>
                          <Divider />
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                            }}
                          >
                            <div style={{ width: 210 }}>
                              <div style={{ float: 'right', marginRight: 8 }}>
                                <Text strong>
                                  Confluence space<Text>(optional)</Text>:
                                </Text>
                              </div>
                            </div>

                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                              }}
                            >
                              <div style={{ marginRight: 16 }}>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                  }}
                                >
                                  <div>
                                    <Select
                                      style={{ width: 200 }}
                                      placeholder='Select Space'
                                      value={
                                        selectedSpace && selectedSpace.key
                                          ? selectedSpace.key
                                          : null
                                      }
                                      onChange={(value, data) =>
                                        onSpaceChange({ value, data })
                                      }
                                      allowClear
                                      loading={confluence_spaces.length === 0}
                                    >
                                      {confluence_spaces.map((space) => {
                                        return (
                                          <Option
                                            key={space.key}
                                            value={space.key}
                                            space={space}
                                          >
                                            {space.name}
                                          </Option>
                                        );
                                      })}
                                    </Select>
                                    {/* {spaceError && (
                                      <>
                                        <br />
                                        <Text type='danger'>* Please select space</Text>
                                      </>
                                    )} */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : actionType === 'search_confluence' ? (
                        <>
                          <Divider />
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                            }}
                          >
                            <div style={{ width: 210 }}>
                              <div style={{ float: 'right', marginRight: 8 }}>
                                <Text strong>
                                  Confluence spaces<Text>(optional)</Text>:
                                </Text>
                              </div>
                            </div>

                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                              }}
                            >
                              <div style={{ marginRight: 16 }}>
                                <div
                                  style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                  }}
                                >
                                  <div>
                                    <Select
                                      style={{ width: 200 }}
                                      placeholder='Select Spaces'
                                      value={
                                        selectedSearchSpaces &&
                                          selectedSearchSpaces.length > 0
                                          ? selectedSearchSpaces.map(
                                            (space) => space.key
                                          )
                                          : []
                                      }
                                      onChange={(value, data) =>
                                        onSearchSpacesChangeChange({
                                          value,
                                          data,
                                        })
                                      }
                                      allowClear
                                      loading={confluence_spaces.length === 0}
                                      mode='multiple'
                                    >
                                      {confluence_spaces.map((space) => {
                                        return (
                                          <Option
                                            key={space.key}
                                            value={space.key}
                                            space={space}
                                          >
                                            {space.name}
                                          </Option>
                                        );
                                      })}
                                    </Select>
                                    {/* {spaceError && (
                                      <>
                                        <br />
                                        <Text type='danger'>* Please select space</Text>
                                      </>
                                    )} */}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </>
                      ) : actionType === 'add_reply_message' ? (
                        <>
                          <Divider />
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              alignItems: 'center',
                            }}
                          >
                            <div style={{ width: 210 }}>
                              <div style={{ float: 'right', marginRight: 8 }}>
                                <Text strong>Message:</Text>
                              </div>
                            </div>
                            <div style={{ width: 500 }}>
                              <RichTextEditor
                                editorState={editorState}
                                handleEditorStateChange={
                                  handleEditorStateChange
                                }

                                errorMessage={editorErrorMessage}

                              />
                              <Text type='secondary'>
                                Specify @@@user@@@ in the message to mention
                                users.
                              </Text>
                            </div>
                          </div>
                        </>
                      ) : (
                        ''
                      )}
                    </div>
                    <Divider />
                  </div>
                  <div style={{ display: 'flex', flex: '0 1 40px' }}>
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                      }}
                    >
                      <div style={{ width: 200 }}></div>
                      <div>
                        <Button
                          type='primary'
                          onClick={() => createNewEmojiAction()}
                          loading={apiLodaing}
                        >
                          {selectedActionForUpadate
                            ? 'Update Emoji Action'
                            : 'Create Emoji Action'}
                        </Button>
                      </div>
                    </div>
                  </div>
                </Card>
              </>
            ) : (
              <Card
                title={
                  <Button
                    type='primary'
                    onClick={createCommand}
                    disabled={
                      !(
                        (isJiraProductsEnabled && jiraSkill_linked) ||
                        (isWikiEnabled && wikiSKill_linked)
                      )
                    }
                  >
                    + New Emoji Action
                  </Button>
                }
              >
                <Table
                  // dataSource={[troopr_emoji_action, ...emojiActions]}
                  onChange={(pagination, filters, sorter) =>
                    handleChange(pagination, filters, sorter)
                  }
                  dataSource={
                    emojiActions
                      ? emojiActions.filter((action) =>
                        actionOptions.find(
                          (option) => option.value === action.actionType
                        )
                      )
                      : []
                  }
                  columns={columns}
                  /* pagination={{ pageSize: 6 }} */ /* loading={members.length} */
                  pagination={false}
                  scroll={{
                    y: '50vh',
                  }}
                />
              </Card>
            )}
          </>
        ) : (
          <Spin style={{ marginLeft: '50%', marginTop: '25%' }} />
        )}
      </Content>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    isAdmin: state.common_reducer.isAdmin,
    allProjects: state.skills.projects,
    jsd_projects: state.skills.jsd_projects,
    issues: state.skills.issues,
    requestTypes: state.skills.requestTypes,
    skills: state.skills.skills,
    team: state.skills.team,

    user_now: state.common_reducer.user,
    confluence_spaces: state.skills.confluence_spaces,
    channels: state.skills.channels,
  };
};

export default connect(mapStateToProps, {
  getProject,
  getIssues,
  searchJiraProjects,
  dropDownSearchJiraProjects,
  getConfluenceSpaces,
  getServiceDeskProject,
  emptyProjectValues,
  getChannelList,
})(EmojiActions);
